import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "pop-parent-log" };
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-2 tw-py-2 tw-pl-3 tw-pr-2 tw-rounded-full tw-cursor-pointer tw-bg-hover tw-justify-between sm:tw-justify-[unset]" };
const _hoisted_3 = { class: "tw-text-[13px] tw-font-semibold tw-text-nowrap" };
const _hoisted_4 = { class: "tw-text-white" };
const _hoisted_5 = { class: "tw-text-sm tw-cursor-pointer" };
const _hoisted_6 = { class: "tw-px-5 tw-py-2 tw-transition-all hover:tw-bg-hover" };
import { useI18n } from 'vue-i18n';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Popover, PopoverContent, PopoverTrigger, } from '@/components/ui/popover/index';
import Icon from '@/components/icon.vue';
/* eslint-disable */
import { usePopupStore } from '@/stores/popup';
const __default__ = {
    methods: {
        openPopup(popup) {
            const popupStore = usePopupStore();
            popupStore.showPopup(popup);
        },
    },
};
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ProfilePopover',
    props: {
        user: {
            type: Object,
            required: true,
        },
        logout: {
            type: Function,
            required: true,
        },
    },
    setup(__props) {
        const { t } = useI18n();
        // import { useRoute, useRouter } from "vue-router";
        // SHADCDN COMPONENTS
        // CUSTOM COMPONENT
        // AUTH COMPOSABLE
        // import { useAuth } from "@/auth/useAuth";
        // Define the `user` prop here
        const props = __props;
        // const route = useRoute();
        // const router = useRouter();
        // const { user, logout } = useAuth();
        const handleLogout = async () => {
            await props.logout();
            // router.replace({
            //   name: "Login",
            //   query: { redirect: route.fullPath }
            // });
        };
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Popover), null, {
                    default: _withCtx(() => [
                        _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("p", _hoisted_3, [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('hi')) + " " + _toDisplayString(props.user?.username || ''), 1)
                                    ]),
                                    _createVNode(_unref(Avatar), {
                                        size: "xs",
                                        class: "tw-border tw-rounded-2xl tw-w-5 tw-h-5 md:tw-w-6 md:tw-h-6 tw-flex tw-items-center tw-justify-center"
                                    }, {
                                        default: _withCtx(() => [
                                            (props.user?.photoURL)
                                                ? (_openBlock(), _createBlock(_unref(AvatarImage), {
                                                    key: 0,
                                                    src: props.user.photoURL,
                                                    alt: "User"
                                                }, null, 8, ["src"]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_unref(AvatarFallback), { class: "tw-text-black" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(props.user?.username?.charAt(0).toUpperCase()), 1)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(PopoverContent), { class: "tw-w-[200px] tw-py-2 tw-px-0 tw-rounded-lg !tw-z-[999]" }, {
                            default: _withCtx(() => [
                                _createElementVNode("ul", _hoisted_5, [
                                    _createElementVNode("li", {
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#withdrawModal",
                                        class: "tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2 tw-transition-all hover:tw-bg-hover",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.openPopup('withdraw')))
                                    }, [
                                        _createVNode(Icon, {
                                            name: "User",
                                            size: 18,
                                            class: "tw-text-muted"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)('withdraw')), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_6, [
                                        _createVNode(_component_router_link, {
                                            to: "/history",
                                            class: "tw-flex tw-items-center tw-gap-2"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(Icon, {
                                                    name: "Settings",
                                                    size: 18,
                                                    class: "tw-text-muted"
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(_unref(t)('history')), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _cache[2] || (_cache[2] = _createElementVNode("li", { class: "py-1" }, [
                                        _createElementVNode("hr", { class: "tw-border-0 tw-border-b tw-border-b-gray-200 dark:tw-border-b-gray-700" })
                                    ], -1)),
                                    _createElementVNode("li", {
                                        class: "tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2 tw-transition-all hover:tw-bg-hover",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (handleLogout()))
                                    }, [
                                        _createVNode(Icon, {
                                            name: "LogOut",
                                            size: 18,
                                            class: "tw-text-muted"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)('logOut')), 1)
                                    ])
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
